import routesMap from "routeControl/userRouteMap";

export const classicDateFormat = "DD/MM/YYYY";
export const dateFormatWithMonth = "DD MMM YYYY";
export const dateTimeFormatWithMonth = "MMM DD YYYY, hh:mm A";
export const timeFormatA = "hh:mm A";
export const classicDataTimeFormate = "DD/MM/YYYY, hh:mm A";
export const dateWithString = "DD MMM YYYY";
export const dateAndTimeFormateWithSlash = "DD/MMM/YYYY, hh:mm a";
export const dateFormateWithOutSlash = "YYYY-MM-DD";
export const payloadDateTimeFormat = "YYYY-MM-DD HH:mm:ss";
export const dobFormate = "MM-DD-YYYY";
export const timeFormate = "hh:mm:ss a";
export const dateFormateYearMonth = "YYYY/MM/DD";
export const newDateFormatter = "DD/MM/YYYY - hh:mm A";
export const DateMonthYearFormate = "DD-MM-YYYY";
export const dateWithMonthYear = "MMM YYYY";
export const DateFormatess = "MMM DD, YYYY";

export const ext = {
  jpg: "image",
  png: "image",
  jpeg: "image",
  JPG: "image",
  PNG: "image",
  JPEG: "image",
  mp3: "audio",
  MP3: "audio",
  mp4: "video",
  MP4: "video",
  pdf: "file",
  wav: "audio",
  file: "pdf",
};

export const nav = {
  theme01: routesMap.Theme01.path,
  theme02: routesMap.THEME02.path,
  theme03: routesMap.THEME03.path,
  theme04: routesMap.THEME04.path,
};
